import { formatErrorMessages } from '@core/adapters/errors/transformError';
import type { DomainError } from '@core/domain';
import { Icon, Warning, IconSize } from '@soteria/design-system-ve';

import * as styles from './ErrorDisplay.css';

interface ErrorDisplayProps {
  errors: DomainError[] | null;
}

/**
 * ErrorDisplay component to render classification errors
 * Extracts error rendering logic from the main component
 */
export function ErrorDisplay({ errors }: ErrorDisplayProps) {
  if (!errors || errors.length === 0) {
    return null;
  }

  const correlationIds = errors.map(error => error.correlationId).filter((id): id is string => Boolean(id));

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorRow}>
        <Icon className={styles.errorIcon} icon={Warning} iconSize={IconSize.XSmall} />
        <span className={styles.errorText}>There was an error classifying the content:</span>
        <span className={styles.errorText}>{formatErrorMessages(errors).join(', ')}</span>
      </div>
      {correlationIds.length > 0 && (
        <span className={styles.errorText}>
          Correlation ID{correlationIds.length > 1 ? 's' : ''}: {correlationIds.join(', ')}
        </span>
      )}
    </div>
  );
}
